<template>
  <div>
    <div class="header">
      <Header></Header>
    </div>
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <div class="all" style="background-color: white">
          <el-row>
            <el-col :span="24">
              <el-steps :active="active1" align-center style="background:#DCDFE6;height: 70px;padding-top: 40px">
                <el-step title="Hotel reservation"></el-step>
                <el-step title="To complete the payment"></el-step>
                <el-step title="Reservation success"></el-step>
              </el-steps>
            </el-col>
          </el-row>
          <div v-if="active1===1">

            <!--          酒店房间选择-->
            <el-row type="flex" justify="center">
              <el-col :span="22">
                <div class="title" style="margin-top: 35px">Hotel Room selection (only one type of room in one hotel can be booked at a time. Only a deposit is required for this booking process.)</div>
              </el-col>
            </el-row>
            <el-row type="flex" justify="center">
              <el-col :span="22" style="margin-top: 35px">
                <el-collapse v-model="activeNames">
                  <el-collapse-item v-for="item in tableData"  :name="item.hotelId" :key="item.hotelId" style="margin-bottom: 20px">
                    <template slot="title">
                      hotel name:{{item.hotelName}}
                    </template>
                    <div>
                      <span style="margin-left: 15px">star level:{{item.stars}}</span>
                      <span style="margin-left: 15px">hotel website:{{item.websiteUri}}</span>
                      <i class="header-icon el-icon-info"></i>
                    </div>
                    <p style="margin-left: 15px;;display: inline-block;max-width:200px;line-height: 100%">酒店说明:{{item.hotelDescription}}</p>
                    <el-table
                        border
                        :data="item.policylist"
                        style="width: 100%;">
                      <el-table-column
                          prop="roomName"
                          label="house type">
                      </el-table-column>
                      <el-table-column
                          prop="policyDescription"
                          label="price">
                      </el-table-column>
                      <el-table-column
                          prop="fee"
                          label="reservation deposit(RMB)">
                      </el-table-column>
                      <el-table-column
                          prop="surplusTotal"
                          label="Total number of rooms remaining">
                        <template slot-scope="scope">
                          <span>{{scope.row.surplusTotal>=0?scope.row.surplusTotal-scope.row.num:9999}}</span>
                        </template>
                      </el-table-column>
                      <el-table-column
                          fixed="left"
                          prop="num"
                          label="Select the number of rooms">
                        <template slot-scope="scope">
                          <el-input-number v-model="scope.row.num" :min="0" :max="scope.row.surplusTotal>=0?scope.row.surplusTotal:9999" :disabled="!scope.row.disabled || scope.row.surplusTotal===0"   @change="getTotal(scope.row.num,scope.row.fee,scope.row);"></el-input-number>
                        </template>
                      </el-table-column>
                      <el-table-column
                          fixed="right"
                          prop="total"
                          label="total(RMB)">
                      </el-table-column>
                    </el-table>
                  </el-collapse-item>
                </el-collapse>
                <el-row style="margin: 25px">
                  <el-col :offset="21" :span="4">
                    <span style="color: #1da7fe !important;font-size: 18px">amount in total：￥{{this.allTotal}}</span>
                  </el-col>
                </el-row>


              </el-col>
            </el-row>

            <!--          入住时间选择-->
            <el-row v-if="totalNum" type="flex" justify="center">
              <el-col :span="22">
                <div class="title" style="margin-top: 35px">Check-in time Selection</div>
              </el-col>
            </el-row>
            <el-row v-if="totalNum" type="flex" justify="left">
              <el-col :offset="5" :span="2"  style="margin-top: 55px;margin-bottom: 50px;text-align: center">
                <span style="font-size: 18px">check-in time：</span>
              </el-col>
              <el-col :span="4"  style="margin-top: 50px;margin-bottom: 50px">
                <el-date-picker
                    v-model="startDate"
                    :picker-options="pickerOptions1"
                    type="date"
                    @change="click"
                    placeholder="check-in time"
                    format="yyyy / MM / dd "
                    value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
              <el-col  :offset="1" :span="2"  style="margin-top: 55px;margin-bottom: 50px;text-align: center">
                <span style="font-size: 18px">check-out time：</span>
              </el-col>
              <el-col  :span="4"  style="margin-top: 50px;margin-bottom: 50px">
                <el-date-picker
                    :disabled="startDate===''||startDate === null"
                    v-model="endDate"
                    :picker-options="pickerOptions2"
                    type="date"
                    placeholder="check-out time"
                    format="yyyy / MM / dd "
                    value-format="yyyy-MM-dd">
                </el-date-picker>
              </el-col>
            </el-row>

            <el-row type="flex" justify="center" style="height: 150px">
              <el-col :span="2">
                <el-button  v-if="startDate && endDate" type="primary" v-preventReClick @click="toNext" style="margin-top: 35px;margin-bottom: 35px">next step</el-button>
              </el-col>
            </el-row>
          </div>

          <div v-if="active1===2">
            <el-row type="flex" justify="center">
              <el-col :span="22"><div class="title" style="margin-top: 35px">Choice of Payment Method</div></el-col>
            </el-row>
            <el-row type="flex" justify="center" style="margin-top: 50px">
              <el-col :span="22">
                <el-tabs style="width: 90%;margin: 15px auto 0;" v-model="activeName" @tab-click="handleClick">
<!--                  <el-tab-pane name="wxpay" label="WeChat Pay">-->
<!--                    <div v-if="payWeixin === 1" style="margin-bottom: 50px">-->
<!--                      <el-row type="flex" justify="center">-->
<!--                        <el-col style="text-align: center;width: 150px;">-->
<!--                          <h3 style="color: red">￥{{amount}}</h3>-->
<!--                        </el-col>-->
<!--                      </el-row>-->
<!--                      <el-row type="flex" justify="center">-->
<!--                        <el-col style="text-align: center;width: 250px;">-->
<!--                          <span>Please pay by scanning code on wechat</span>-->
<!--                        </el-col>-->
<!--                      </el-row>-->
<!--                      <el-row type="flex" justify="center">-->
<!--                        <el-col style="width: 340px;text-align: center">-->
<!--                          <vue-qr style="margin-top: 20px;margin-left: 10px" :logoSrc="imgUrl"  :text="img" :size="200"></vue-qr>-->
<!--                        </el-col>-->
<!--                      </el-row>-->
<!--                      <el-row type="flex" justify="center">-->
<!--                        <el-col style="width: 340px;text-align: center;margin-bottom: 50px">-->
<!--                          <span style="font-size: 12px">order number：{{orderNo}}</span>-->
<!--                        </el-col>-->
<!--                      </el-row>-->
<!--                    </div>-->
<!--                    <div v-if="payWeixin === 2">-->
<!--                      <el-result icon="success" title="payment success">-->
<!--                        <template slot="extra">-->
<!--                          <span style="font-size: 14px">{{sendmsg}}After the jump booking completion page</span>-->
<!--                        </template>-->
<!--                      </el-result>-->
<!--                    </div>-->
<!--                    <div v-if="payWeixin === 3">-->
<!--                      <el-result icon="error" title="payment failure" subTitle="Perform operations as prompted">-->
<!--                        <template slot="extra">-->
<!--                          <el-button type="primary" size="medium" @click="back">Return type selection</el-button>-->
<!--                        </template>-->
<!--                      </el-result>-->
<!--                    </div>-->
<!--                    <div v-if="payWeixin === 4">-->
<!--                      <el-result icon="warning" title="The order has timed out" subTitle="Perform operations as prompted">-->
<!--                        <template slot="extra">-->
<!--                          <el-button type="primary" size="medium"  @click="back">Return type selection</el-button>-->
<!--                        </template>-->
<!--                      </el-result>-->
<!--                    </div>-->
<!--                  </el-tab-pane>-->
                  <el-tab-pane name="offline" label="bank transfer">
                    <el-row type="flex" justify="center">
                      <el-col :span="3">
                        <h3 style="color: red">￥{{amount}}</h3>
                      </el-col>
                    </el-row>
                    <el-row type="flex" justify="center">
                      <el-col :span="7" style="">
                        <span style="font-size: 12px">Order number：{{orderNo}}</span>
                      </el-col>
                    </el-row>
<!--                    <el-row type="flex" justify="center">-->
<!--                      <el-col :span="4">-->
<!--                        <el-button style="margin: 50px 0 50px 15px" type="primary" @click="payOffline">线下支付</el-button>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
                  </el-tab-pane>
<!--                  <el-tab-pane name="sitepay" label="现场支付">-->
<!--                    <el-row type="flex" justify="center">-->
<!--                      <el-col :span="3">-->
<!--                        <h3 style="color: red">￥{{amount}}</h3>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                    <el-row type="flex" justify="center">-->
<!--                      <el-col :span="7" style="">-->
<!--                        <span style="font-size: 12px">订单号：{{orderNo}}</span>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                    <el-row type="flex" justify="center">-->
<!--                      <el-col :span="4">-->
<!--                        <el-button style="margin: 50px 0 50px 15px" type="primary" @click="paySitePay">现场支付</el-button>-->
<!--                      </el-col>-->
<!--                    </el-row>-->
<!--                  </el-tab-pane>-->
                </el-tabs>
              </el-col>
            </el-row>
          </div>

          <div v-if="active1===3">
            <el-result v-if="this.activeName==='wxpay'" icon="success" title="Reservation success">
              <template slot="extra">
                <h3 style="color: red">￥{{amount}}</h3>
                <span style="font-size: 12px">order number：{{orderNo}}</span>
                <p style="font-size: 14px">You can visit the personal center to view the order information</p>
              </template>
            </el-result>
            <el-result v-if="this.activeName==='offline'" icon="success" title="Reservation success,Please complete the transfer to the company">
              <template slot="extra">
                <h3 style="color: red">￥{{amount}}</h3>
                <span style="font-size: 12px">order number：{{orderNo}}</span>
                <p style="font-size: 20px">Transfer money to the company：</p>
                <h5>account name：{{accountName}}</h5>
                <h5>bank of deposit：{{bank}}</h5>
                <h5>bank account：{{accountNum}}</h5>
                <span  style="color: red;font-size: 18px">matters need attention：</span>
                <span v-html="remark" style="color: red;font-size: 16px"></span>
              </template>
            </el-result>
            <el-result v-if="this.activeName==='sitepay'" icon="success" title="Reservation success">
              <template slot="extra">
                <h3 style="color: red">￥{{amount}}</h3>
                <span style="font-size: 12px">order number：{{orderNo}}</span>
                <p style="font-size: 14px">You can visit the personal center to view the order information</p>
              </template>
            </el-result>
          </div>


        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import vueQr from "vue-qr";
export default {
  name: "setHotel",
  components: {
    vueQr
  },
  data(){
    return{
      //全局
      confId:'',
      allTotal:'',
      totalNum:'',
      policyId:'',

      //流程
      active1:1,

      //酒店预订
      startDate:'',
      endDate:'',
      startDateA:'',
      endDateA:'',
      activeNames: [],

      //酒店预订信息
      tableData:[],

      //active2
      payWeixin:1,
      activeName:'wxpay',
      imgUrl:require("../assets/logo1.jpg"),
      img: '',
      code:'',
      money:'',
      sendmsg:'',
      orderNo:'',
      amount:'',
      accountName:'',
      bank:'',
      accountNum:'',
      remark:'',
      //支付状态刷新定时器
      time:'',

      //时间选择器选择范围
      pickerOptions1: {
        disabledDate:(time)=>{
          return time.getTime() < new Date(this.startDateA)- 8.64e7  || time.getTime() > new Date(this.endDateA)
        }
      },
      pickerOptions2: {
        disabledDate:(time)=>{
          return time.getTime() < new Date(this.startDate)- 8.64e7  || time.getTime() > new Date(this.endDateA)
        }
      }
    }
  },
  methods:{

    //active2
    //切换支付方式
    handleClick(tab){
      if(tab.name ==='wxpay'){
        clearInterval(this.time)
        this.payWx()
        this.activeName='wxpay'
      }else if(tab.name === 'offline'){
        this.activeName='offline'
        clearInterval(this.time)
      }else if(tab.name === 'sitepay'){
        this.activeName='sitepay'
        clearInterval(this.time)
      }
    },
    //提交微信支付订单信息
    async payWx(){
      const { data: res } = await this.$http.post('api/conference/pay/roomOrder/nativePay',
          {policyId:this.policyId,quantity:this.totalNum,startDate:this.startDate,endDate:this.endDate,payTool:'wxpay'})
      // console.log(res);
      if(res.code === 200){
        var that = this;
        this.orderNo = res.result.orderNo
        this.img = res.result.codeUrl
        this.amount = res.result.amount
        this.payWeixin = 1
        this.time = setInterval(function (){
          that.getPayState()
        },1000)
      }else{
        return this.$message.error(res.msg)
      }
    },
    //提交银行订单信息
    async payOffline(){
      const { data: res } = await this.$http.post('api/conference/pay/roomOrder/nativePay',
          {policyId:this.policyId,quantity:this.totalNum,startDate:this.startDate,endDate:this.endDate,payTool:'remitpay'})
      console.log(res);
      if(res.code === 200){
        this.active1+=1
        this.getOffline()
      }else{
        return this.$message.error(res.msg)
      }

    },
    //获取线下支付信息
    async getOffline(){
      const { data: res } = await this.$http.get('api/conference/bankConfig')
      if(res.code === 200){
        console.log(res);
        this.accountName = res.data.accountName
        this.accountNum = res.data.accountNum
        this.bank = res.data.bank
        this.remark = res.data.remark
      }else{
        return this.$message.error(res.msg)
      }
      // console.log(res);
    },
    //提交现场支付订单信息
    async paySitePay(){
      const { data: res } = await this.$http.post('api/conference/pay/roomOrder/nativePay',
          {policyId:this.policyId,quantity:this.totalNum,startDate:this.startDate,endDate:this.endDate,payTool:'sitepay'})
      console.log(res);
      if(res.code === 200){
        this.active1+=1
      }else{
        return this.$message.error(res.msg)
      }
    },
    //获取支付状态
    async getPayState(){
      const { data: res } = await this.$http.post('api/conference/pay/roomOrder/check/'+this.orderNo)
      console.log(res);
      if(res.code === 200){
        this.$message.success('支付成功')
        this.payWeixin = 2
        clearInterval(this.time)
        let timer = 3;
        this.sendmsg = timer + "s";
        this.timeFun = setInterval(() => {
          --timer;
          this.sendmsg = timer + "s";
          if (timer === 0) {
            this.sendmsg = "";
            clearInterval(this.timeFun);
            this.active1+=1
          }
        }, 1000);
      }else if(res.code === 201){
        this.payWeixin1 = 1
      }else if(res.code === 202){
        this.$message.warning('The order has timed out')
        this.payWeixin1 = 4
        clearInterval(this.time1)
      }else if(res.code === 203){
        this.$message.error('Order payment failed')
        this.payWeixin1 = 3
        clearInterval(this.time1)
      }
    },
    //微信支付返回第一步
    back(){
      this.active1-=1
    },


    //时间选择器清除事件
    click(){
      this.endDate = ''
    },
    //下订单
    async toNext(){
      this.payWx()
      this.active1+=1
      this.payWeixin = 1
    },
    //获取酒店信息
    async getList(){
      const { data: res } = await this.$http.post('api/conference/roomPolicy/pcweb/allList/'+this.confId)
      console.log(res);
      if(res.code === 200){
        this.tableData = res.data
      }else {
        this.$message.error(res.msg)
      }
      // console.log(this.tableData);
    },
    //获得单策略总价格
    getTotal(a,b,scopeRow){
      // console.log(scopeRow);
      if(scopeRow.num===0) {
        return scopeRow.total = 0
      }else if(scopeRow.num>0){
        return scopeRow.total = b
      }
    },
    //获得总价格和总数量
    getAllTotal(){
      let alltotal = 0;
      let totalNum = 0;
      for(let i=0;i<this.tableData.length;i++){
        for(let j=0;j<this.tableData[i].policylist.length;j++){
          alltotal += this.tableData[i].policylist[j].total
          totalNum += this.tableData[i].policylist[j].num
        }
      }
      this.allTotal = alltotal
      this.totalNum = totalNum
    },
    //控制计数器禁用
    changeDisabled(){
      if(this.totalNum !== 0){
        for(let i=0;i<this.tableData.length;i++){
          for(let j=0;j<this.tableData[i].policylist.length;j++){
            if(this.tableData[i].policylist[j].num === 0){
              this.tableData[i].policylist[j].disabled = false
            }
            if(this.tableData[i].policylist[j].num !== 0){
              this.policyId = this.tableData[i].policylist[j].policyId
              this.startDateA = this.tableData[i].policylist[j].startDate
              this.endDateA = this.tableData[i].policylist[j].endDate
            }
          }
        }
      }
      if(this.totalNum === 0){
        for(let i=0;i<this.tableData.length;i++){
          for(let j=0;j<this.tableData[i].policylist.length;j++){
            this.tableData[i].policylist[j].disabled = true
          }
        }
      }
    },
  },
  watch:{
    tableData:{
      handler() {
        this.getAllTotal()
        this.changeDisabled()
      },
      deep: true,
      immediate:true,
    },
  },
  mounted() {
    this.getList()
  },
  created() {
    this.confId = this.$route.query.id
    // console.log(this.confId);
  },
}
</script>

<style scoped lang="less">
.page{
  background-color: #f2f2f2;
}
.title{
  /*height: ;*/
  font-size: 18px;
  width: 100%;
  height: 35px;
  line-height: 35px;
  padding-left: 10px;
  color: #1da7fe;
  border-left: solid 6px #1da7fe !important;
  border-right: solid 3px #1da7fe !important;
  background-color: #fbfbfb;
}
#one .el-radio{
  margin-top: 15px;
}

</style>

